import React, { useEffect, useState } from "react";
import { App, Button, Card, Dropdown, Modal, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdOutlineScreenShare } from "react-icons/md";
import { HiOutlineChevronDown } from "react-icons/hi";
import AppControl from "../../components";
import { getScreens, deleteScreen } from "../../store/slice/screens";

function Screens() {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { message } = App.useApp();

  const { list } = useSelector((state) => state.screens);

  useEffect(() => {
    dispatch(getScreens());
  }, [dispatch]);

  const showDeleteConfirm = (row) => {
    setModalText(`Are you sure you want to delete "${row.title}"?`);
    setDeleteId(row.id);
    setOpen(true);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    const resultAction = await dispatch(deleteScreen(deleteId));
    setOpen(false);
    setConfirmLoading(false);
    if (deleteScreen.fulfilled.match(resultAction)) {
      message.success(resultAction.payload.message);
      dispatch(getScreens());
    } else {
      message.error(resultAction.error.message);
    }
  };

  const COLUMNS = [
    { Header: "Id", accessor: "id", isVisible: false, disableFilters: true },
    { Header: "Key", accessor: "key" },
    { Header: "Title", accessor: "title" },
    {
      Header: "Permissions",
      accessor: "children",
      disableFilters: true,
      Cell: ({ value }) =>
        Array.isArray(value)
          ? value.map((c) => (
              <Tag key={c.key} color="blue" className="mb-1">
                {c.title}
              </Tag>
            ))
          : null,
    },
    {
      Header: "Actions",
      disableFilters: true,
      Cell: ({ row }) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "edit",
                label: (
                  <span onClick={() => navigate(`edit/${row.values.id}`)}>
                    Edit
                  </span>
                ),
              },
              {
                key: "delete",
                danger: true,
                label: (
                  <span onClick={() => showDeleteConfirm(row.values)}>
                    Delete
                  </span>
                ),
              },
            ],
          }}
        >
          <Button>
            <Space>
              Actions <HiOutlineChevronDown />
            </Space>
          </Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <Card
      title="SCREEN LIST"
      extra={
        <AppControl
          control="button"
          type="button"
          name="Add New Screen"
          size="full"
          color="orange"
          icon={<MdOutlineScreenShare size="1.25em" className="inline mr-1" />}
          onClick={() => navigate("add")}
        />
      }
    >
      <AppControl control="table" columns={COLUMNS} data={list} />
      <Modal
        title="Delete Screen"
        open={open}
        okText="Yes, Delete!"
        okType="danger"
        onOk={handleOk}
        confirmLoading={confirmLoading}
        cancelText="No, Cancel"
        onCancel={() => setOpen(false)}
      >
        <p>{modalText}</p>
      </Modal>
    </Card>
  );
}

export default Screens;
